import {
  Root as SliderRoot,
  Track as SliderTrack,
  Range as SliderRange,
  Thumb as SliderThumb,
} from "@radix-ui/react-slider";
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from "react";

/**
 * Dual-thumb range slider with for price range selection.
 */
export const DualRangeSlider = forwardRef<
  ComponentRef<typeof SliderRoot>,
  ComponentPropsWithoutRef<typeof SliderRoot> & {
    thumbLabel: string;
  }
>(({ className, thumbLabel, ...props }, ref) => (
  <SliderRoot {...props} ref={ref} className={`relative ${className}`}>
    <SliderTrack className="relative block h-2 w-full rounded-lg border border-neutral-500 bg-white">
      <SliderRange className="bg-primary absolute block h-full rounded-lg" />
    </SliderTrack>
    <SliderThumb
      className="focus:border-darkGrey absolute -top-3 block h-4 w-4 translate-x-[-50%] cursor-pointer rounded-full border border-neutral-500 bg-white ring-neutral-500 focus:border-2 focus:outline-hidden"
      aria-label={`${thumbLabel} minimum`}
    >
      <span className="bg-primary absolute top-1/2 left-1/2 block h-1 w-1 translate-x-[-50%] translate-y-[-50%] rounded-full border"></span>
    </SliderThumb>
    <SliderThumb
      className="focus:border-darkGrey absolute -top-3 block h-4 w-4 translate-x-[-50%] cursor-pointer rounded-full border border-neutral-500 bg-white ring-neutral-500 focus:border-2 focus:outline-hidden"
      aria-label={`${thumbLabel} maximum`}
    >
      <span className="bg-primary absolute top-1/2 left-1/2 block h-1 w-1 translate-x-[-50%] translate-y-[-50%] rounded-full border"></span>
    </SliderThumb>
  </SliderRoot>
));

DualRangeSlider.displayName = "DualRangeSlider";
